import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/onboarding/index.js